import { render, staticRenderFns } from "./DashboardCalender.vue?vue&type=template&id=4509e012"
import script from "./DashboardCalender.vue?vue&type=script&lang=js"
export * from "./DashboardCalender.vue?vue&type=script&lang=js"
import style0 from "./DashboardCalender.vue?vue&type=style&index=0&id=4509e012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports